export default __webpack_public_path__ + "static/media/hero-right.8e5a74e5.png";